module.exports = __webpack_public_path__ + "static/media/IMG_4271.00a9855f.PNG";